import { SxProps } from '@mui/material';
import { colorPalette } from '@qualifio/ui-commons';

export const sidebarAlertStyle: SxProps = {
  padding: 1,
  borderBottom: `1px solid ${colorPalette.grey.main}`,
};
